import { render, staticRenderFns } from "./RulesView.vue?vue&type=template&id=77a73fd5&scoped=true"
import script from "./RulesView.vue?vue&type=script&lang=ts"
export * from "./RulesView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a73fd5",
  null
  
)

export default component.exports